import React from 'react';
import FuturaCleaningTab from '@/components/FuturaCleaningTab';

const FuturaCleaning = () => {
    return (
        <div className="pt-24 pb-16 container mx-auto px-4">
            <h1 className="text-4xl font-bold mb-8 text-center">Futura Cleaning Services</h1>
            <FuturaCleaningTab />
        </div>
    );
};

export default FuturaCleaning;
